import React from "react";
import PropTypes from "prop-types";
import {Button, ButtonGroup} from "semantic-ui-react";
import AssociatedServicesTable from "./AssociatedServicesTable";

export default class ProviderDetailInfo extends React.Component {

    static propTypes = {
        providerDetail: PropTypes.object,
        associatedServices: PropTypes.array,
    }

    render() {

        const {providerDetail, associatedServices} = this.props;

        return(
            <div className="detail-container">
                <div>
                    <ButtonGroup>
                        <Button
                            content="Overview"
                        />
                    </ButtonGroup>
                    <div className="detail-info">
                        <div>
                            <span>Monthly Minimum</span>
                            <p>
                                {providerDetail.provider_detail.monthly_aggregate_volume === null
                                    ? null
                                    : `${providerDetail.provider_detail.monthly_aggregate_volume} Monthly`}
                            </p>
                        </div>

                        <div>
                            <h3 style={{marginBottom: "0"}}>Contact(s):</h3>
                            <div className={"contact-info-container"}>
                                {providerDetail.contact_information
                                    ? providerDetail.contact_information.map((contact, idx) => {
                                        return (
                                            <div className={"flex-child"} key={idx}>
                                                <b>{contact.type}</b>
                                                <p>{contact.name}</p>
                                                <p>{contact.email}</p>
                                                <p>{contact.phone_number}</p>
                                            </div>
                                        )
                                    }) : (
                                        <div>
                                            <p>
                                                Not Available.
                                                Please update Contacts associated
                                                with {providerDetail.provider_detail.provider_name}.
                                            </p>
                                        </div>
                                    )
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <AssociatedServicesTable
                    associatedServices={associatedServices}
                />
            </div>
        );
    }
}
